module.exports = __webpack_public_path__ + "assets/img/1r.73702bac.png";